import { Link } from "@tanstack/react-router";
import { Logo } from "../icons/Logo";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-[hsl(213_27%_86%/0.4)] bg-white py-12">
      <div className="max-w-[1200px] mx-auto px-3 sm:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <Logo height={58} />

          {/* Links (Story 30.6 — major sections for crawl discovery + link equity).
              /integrations ships in Story 30.11 (plain <a> until then); /#pricing
              is the homepage pricing section. */}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label="Footer navigation">
            <Link
              to="/blog"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Blog
            </Link>
            <a
              href="/#pricing"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Pricing
            </a>
            <a
              href="/integrations"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Integrations
            </a>
            <Link
              to="/about"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              About
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/waitlist"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Join Waitlist
            </Link>
          </nav>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground">
            &copy; {currentYear} ProvenLeap. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
